import { render, staticRenderFns } from "./fila.vue?vue&type=template&id=da6120a4&scoped=true"
import script from "./fila.vue?vue&type=script&lang=js"
export * from "./fila.vue?vue&type=script&lang=js"
import style0 from "./fila.vue?vue&type=style&index=0&id=da6120a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6120a4",
  null
  
)

export default component.exports